// extracted by mini-css-extract-plugin
module.exports = {"chart":"common-bar_chart_3fqIQ"};